import { render, staticRenderFns } from "./VehicleBatchDetail.vue?vue&type=template&id=64d020d7&scoped=true&"
import script from "./VehicleBatchDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./VehicleBatchDetail.vue?vue&type=style&index=0&id=64d020d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d020d7",
  null
  
)

export default component.exports